export function useEduChildModuleData(child: any) {
  const oneToOne = child?.modules?.ONE_TO_ONE;
  if (!oneToOne) return { universityName: "", courseName: "" };

  let course: any = null;

  // Try direct "course" key first, then scan all entries for model === "course"
  if (oneToOne.course) {
    course = oneToOne.course;
  } else {
    for (const key of Object.keys(oneToOne)) {
      const entry = oneToOne[key];
      if (entry?.model === "course") {
        course = entry;
        break;
      }
    }
  }

  return {
    universityName: course?.university?.value || "",
    courseName: course?.value || "",
  };
}
